<template>
  <div class="container">
    <section class="content-header">
      <h1>{{$t('アカウントの削除')}}</h1>
      <p>{{$t('アカウントの削除が完了しました。')}}</p>
    </section>
    <section class="content-wrap">
      <div class="col-center" style="text-align:center;">
        <a :href="'/'">{{$t('Return to Home Page')}}</a>
      </div>
    </section>
  </div>
</template>


<script>
import Cookie from 'js-cookie'
import { mapState, mapGetters } from 'vuex'

export default {
  data : () => ({
    errors:[],
  }),


  //For Header & Meta Tag 
  metaInfo() {
    return {
      title: this.$t('アカウントの削除') + ' | '+ this.$t('MATCHA - JAPAN TRAVEL WEB MAGAZINE'),
      htmlAttrs: {
        lang: this.$store.state.languageName
      },        
    }
  },    
}

</script>



// WEBPACK FOOTER //
// src/pages/settings/accountdeleted.vue